var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var ShoppingBag = function (props) { return (_jsx("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, props, { children: _jsx("path", { d: "M10.667 7.33333V4.66667C10.667 3.19391 9.47306 2 8.00033 2C6.52757 2 5.33366 3.19391 5.33366 4.66667V7.33333M3.33366 6H12.667L13.3337 14H2.66699L3.33366 6Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }))); };
